module.exports = __webpack_public_path__ + "05_hair_silver.9a4a52fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/05_hair_silver.png
// module id = 4sK3
// module chunks = 0